import { createStyle } from '@gluestack-style/react';

export const ButtonText = createStyle({
  color: '$textLight0',
  textAlign: 'center',
  _web: {
    userSelect: 'none',
  },
});
